import { Component, Input } from '@angular/core';

import { map } from 'rxjs';

import { ISignUpStep } from '../../interfaces/sign-up-step.intf';
import { SignUpFacadeService } from '../../services/sign-up-facade.service';

@Component({
  selector: 'ib-sign-up-wizard-indicators',
  templateUrl: './sign-up-wizard-indicators.component.html',
  styleUrls: ['./sign-up-wizard-indicators.component.scss'],
})
export class SignUpWizardIndicatorsComponent {
  @Input() isCompanyAccount: boolean;

  public btnsState$ = this.signUpFacadeS
    .selectBtnsState()
    .pipe(map(r => ({ v: r })));
  public steps$ = this.signUpFacadeS.selectSteps();

  constructor(public signUpFacadeS: SignUpFacadeService) {}

  setStep(step: ISignUpStep): void {
    this.signUpFacadeS.setStepIndex(step.index);
  }
}
